module.exports = {"PER":{"department":"Departamento","district":"Distrito","dni":"dni","province":"Provincia"},"ECU":{"department":"Provincia","dni":"Cédula","district":"Parroquia","province":"Ciudad"}}


//////////////////
// WEBPACK FOOTER
// ./src/shared/countries.json
// module id = 743
// module chunks = 34